import { atom, useAtom } from 'jotai';

// onConfirm lets each caller decide what "confirm exit" means (navigate elsewhere, log out, etc.)
const showCheckInExitWarningDialog = atom<{ show: boolean; onConfirm?: VoidFunction }>({ show: false });

export const useShowCheckInExitWarningDialog = () => useAtom(showCheckInExitWarningDialog);
